import { AIModelWarningsResponse, AIProviderWithModels } from '../types/chatConfig';
import { ApiClient } from './apiClient';

export class AIModelsService {
  constructor(private api: ApiClient) { }

  async list() {
    const result = await this.api.get<AIProviderWithModels[]>('/api/ai-models');
    if (result.success && result.data) {
      return result.data;
    }
    return [];
  }

  async getWarnings(withinDays = 30) {
    const result = await this.api.get<AIModelWarningsResponse>(
      '/api/ai-models/warnings',
      { withinDays },
      { skipErrorNotification: true }
    );
    if (result.success && result.data) {
      return result.data;
    }
    return null;
  }
}
